/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Sources_PreviousInputs */



/**
* | output |
* | --- |
* | "Previous conversations" |
*
* @param {Meeting_Sources_PreviousInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_previous = /** @type {((inputs?: Meeting_Sources_PreviousInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_PreviousInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Vorige gesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conversations précédentes")
	return /** @type {LocalizedString} */ ("Previous conversations")
});